import React, { useEffect } from "react";
import "./Explore_All.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { useNavigate } from "react-router-dom";
import { AllEventCategories } from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import { encodeId } from "../../../utils/common";

const Explore_All = () => {


  const navigate = useNavigate()
  const dispatch = useDispatch()
  const eventsCats = useSelector((state) => state.common.all_event_categories);

  useEffect(() => {
    dispatch(AllEventCategories());
  }, [dispatch])

  // console.log({ eventsCats });

  const data = [
    {
      label: "Explore All Offerings",
      img: "/assets/images/event_registration/explore_all/img3.png",
    },
  ];


  return (
    <section className="Explore_All Upcoming_events_sec ">
      <div className="container">
        <Common_Title_1 subText="Explore All" />

        <div className="slidersec">
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1.3,
                spaceBetween: 10,
              },
              575: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            modules={[Pagination, Autoplay]}
            className="mySwiper"
          >
            {/* {data.map((item, index) => (
              <SwiperSlide>
                <div className="explore_card" onClick={() => { navigate("/all-shibir") }}>
                  <div className="img_holder">
                    <img
                      src={process.env.PUBLIC_URL + item?.img}
                      className="event_img"
                    />
                  </div>
                  <p className="event_name">{item?.label}</p>

                  <div className="overlay"></div>
                </div>
              </SwiperSlide>
            ))} */}

            {eventsCats?.map((item, index) => (
              <SwiperSlide>
                <div className="explore_card" onClick={() => { navigate(`/all-shibir?event_category_id=${encodeId(item?.Event_category?.id)}`) }}>
                  <div className="img_holder">
                    <img
                      src={IDS.IMG_URL + item?.Event_category?.image}
                      className="event_img"
                    />
                  </div>
                  <p className="event_name">{item?.name}</p>

                  <div className="overlay"></div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Explore_All;
